import React from "react";
import { VMBuilder } from "../../commons/base/providers/builder";
import SoldOutCmsEditorViewModel from "../view_models/sold_out_cms_editor_view_model";

export default class SoldOutCmsFilterWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<SoldOutCmsEditorViewModel>>
                {(vm) => (
                    <div className="flex flex-wrap items-center mb-5 space-y-3 md:space-y-0">
                        {/* Keyword input */}
                        <div className="relative flex-grow mr-2">
                            <input
                                type="text"
                                placeholder="Cari ..."
                                className="px-2 h-9 pr-8 mx-2 block appearance-none w-full bg-white border border-gray-300 rounded-lg shadow leading-tight focus:outline-none focus:shadow-outline"
                                onChange={(e) =>
                                    vm.updateSearchQuery(e.target.value)
                                }
                            />
                        </div>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
